import React, { FC, useEffect, useState } from 'react';
import st from './menuToolbar.module.scss'
import { IconBox, Input, Type as T, HoverProvider } from "@infobis/ui-styles-utils";
import Logo from "../../../elements/logo/Logo";
import Navigation from "../navigation/Navigation";
import MainLinkAccount from "../linkAccount/MainLinkAccount";
import cn from "classnames";
import { useWideScreen } from "@hooks/useWideScreen";
import colors from "@infobis/ui-styles-utils/colors";

interface MenuToolbar {
    isOpenMenu?: any,
    setIsOpenMenu?: any,
    children?: React.ReactNode
}

export interface NavItem {
    name: string
    path: string
    icon: T.IconName
}

const MenuToolbar: FC<MenuToolbar> = (props) => {
    let {
        isOpenMenu,
        setIsOpenMenu
    } = props

    const [filterInput, setFilterInput] = useState<string>("")
    const [navigation, setNavigation] = useState<NavItem[]>([
        { name: 'Мониторинг', path: "/map", icon: T.IconName.Monitoring },
        { name: 'Справочники', path: "/references", icon: T.IconName.Directory },
        { name: 'Отчет', path: "/reports", icon: T.IconName.Report },
        { name: 'Планирование', path: "/plan", icon: T.IconName.Plan },
        { name: 'Аналитика', path: "/dashboards", icon: T.IconName.Analytics },
        { name: 'Бюджетирование', path: "/budget", icon: T.IconName.Budget },
        { name: 'Уведомления', path: "/notifications", icon: T.IconName.NotificationFalse },
        { name: 'Партнёры и сервисы', path: "/partner", icon: T.IconName.StoreFront }
    ])

    useEffect(() => {
        if (!isOpenMenu) setFilterInput("")
    }, [isOpenMenu])

    const isWideScreen = useWideScreen()

    return (
        <div className={cn(st.menu, isOpenMenu && st.menu__open)}>
            <div className={st.logo}>
                <Logo showText={isOpenMenu}/>
            </div>
            <ul className={st.controls}>
                <HoverProvider style={{ display: 'contents' }} key={isOpenMenu}>
                    <li
                        className={cn(st.controls__item, st.controls__item_burger)}
                        onClick={() => setIsOpenMenu((i: boolean) => !i)}
                    >
                        <IconBox
                            icon={isOpenMenu ? T.IconName.Cancel : T.IconName.Hamburger}
                            className={st.icon}
                            size={T.Size.MEDIUM}
                            isWideScreenMode={isWideScreen}
                            color={colors.CONTROL_DEFAULT_MAIN_MENU_ICON}
                            hoverColor={colors.CONTROL_PRIMARY_CONTENT}
                            sizePadding={T.Size.SMALL}
                        />
                    </li>
                </HoverProvider>
                {
                    isOpenMenu ? <Input.Text
                            iconBefore={() =>
                                <IconBox
                                    className={st.searchIcon}
                                    icon={T.IconName.Search}
                                    color={colors.CONTROL_DEFAULT_MAIN_MENU_ICON}
                                    size={isWideScreen ? T.Size.MEDIUM : T.Size.LARGE}
                                    isWideScreenMode={isWideScreen}
                                    sizePadding={T.Size.SMALL}
                                />
                            }
                            onChange={v => setFilterInput(v)}
                            inputClassName={st.controls__search_input}
                            className={st.controls__search}
                            size={T.Size.MEDIUM}
                            width={T.Width.FULL}
                        /> :
                        <li className={cn(st.controls__item, st.searchIconMenuClosed)}
                            onClick={() => setIsOpenMenu((i: boolean) => !i)}>
                            <IconBox
                                icon={T.IconName.Search}
                                size={isWideScreen ? T.Size.MEDIUM : T.Size.LARGE}
                                isWideScreenMode={isWideScreen}
                                sizePadding={T.Size.LARGE}
                                color={colors.CONTROL_DEFAULT_MAIN_MENU_ICON}
                                className={st.icon}
                            />
                        </li>
                }
            </ul>
            <div className={st.navigation}>
                <Navigation
                    isFull={isOpenMenu}
                    navigation={navigation.filter((i) => filterInput === "" || i.name.includes(filterInput))}
                    onNavigationClick={() => setIsOpenMenu((v: boolean) => !v)}
                />

            </div>
            <div className={st.account}>
                <MainLinkAccount isFull={isOpenMenu} openMenu={setIsOpenMenu}/>
            </div>
        </div>
    )
}
export default MenuToolbar;
